export enum OrderProductRowLayout {
  WIDE = 'wide',
  CONDENSED = 'condensed',
  STACKED = 'stacked',
  MOBILE = 'mobile',
}

export interface ResolveOrderProductRowLayoutParams {
  containerWidth: number;
  isMobileViewport: boolean;
  isTabletViewport: boolean;
}

export interface GetOrderProductRowHeightParams {
  layout: OrderProductRowLayout;
  hasTouchGrid: boolean;
}

export interface OrderProductRowInlineSizes {
  imageAndLabel: number;
  color: number;
  deliveryWindow: number;
  columnGap: number;
  gridGap: number;
}

export interface OrderProductSelectSize {
  width?: number;
  height: number;
}

export interface OrderProductRowGutter {
  left: number;
  right: number;
}
